import React, { ReactElement } from 'react'
import { Colors } from '@config/theme/palette'
import { makeStyles } from '@material-ui/core/styles'

import Headline from '@objects/headline'
import Button from '@objects/button'
import { useAutobahnplakateTexts } from '../store'

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative' as const,
    '&:before': {
      content: '""',
      opacity: 0,
      position: 'absolute' as const,
      top: theme.spacing(-4),
      left: theme.spacing(-4),
      height: 'calc(100% + 32px)',
      backgroundColor: theme.palette.common.white,
      zIndex: -1,
      width: '60%',
      [theme.breakpoints.up('md')]: {
        top: 0,
        opacity: 1,
      },
    },
  },
  overline: {
    fontWeight: 900,
  },
  headline: {
    fontWeight: 900,
    fontSize: '2rem',
    margin: 0,
    '& .highlight': {
      color: Colors.green[500],
      backgroundColor: theme.palette.background.default,
    },

    [theme.breakpoints.up('md')]: {
      fontSize: '4rem',
    },
  },
  button: {
    height: '64px',
    fontSize: '22px',
    marginTop: theme.spacing(12),
    [theme.breakpoints.up('lg')]: {
      height: '80px',
      fontSize: '24px',
      marginTop: theme.spacing(8),
    },
  },
}))

export default function Intro(): ReactElement {
  const classes = useStyles()
  const store = useAutobahnplakateTexts()
  const hasVoted = store.hasVotedEffective

  return (
    <div>
      <div className={classes.root}>
        <Headline level={4} className={classes.overline}>
          {store.introOverline}
        </Headline>
        <Headline level={2} className={classes.headline}>
          {!!store.introHeadlineHighlightedWord ? (
            <span
              dangerouslySetInnerHTML={{
                __html: store.introHeadline.replace(
                  store.introHeadlineHighlightedWord,
                  `<span class="highlight">${store.introHeadlineHighlightedWord}</span>`
                ),
              }}
            />
          ) : (
            store.introHeadline
          )}
        </Headline>
      </div>
      {hasVoted ? (
        <Button
          className={classes.button}
          onClick={() => store.slideTo(store.resultSlideIndex)}
          disabled={store.results.length === 0}
        >
          {store.introButtonLabelVoted}
        </Button>
      ) : (
        <Button
          className={classes.button}
          onClick={store.next}
          disabled={store.options.length === 0}
        >
          {store.introButtonLabel}
        </Button>
      )}
    </div>
  )
}
